import React, { useContext } from "react";
import { makeStyles } from "@material-ui/styles";
import { Context } from "../../../plugins/gatsby-plugin-top-layout/context";
import AlgoliaDark from "../../Images/algolia_dark.svg";
import AlgoliaLight from "../../Images/algolia_light.svg";

const useStyles = makeStyles(theme => ({
  poweredBy: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& span": { lineHeight: 1, marginRight: "8px", fontSize: "0.8125rem" },
    "& a": { lineHeight: 1 }
  }
}));

const PoweredBy = () => {
  const classes = useStyles();
  const {
    state: { theme }
  } = useContext(Context);

  return (
    <div className={classes.poweredBy}>
      <span>POWERED BY{` `}</span>
      <a href="https://algolia.com">
        {theme === "light" ? (
          <AlgoliaLight width="75px" />
        ) : (
          <AlgoliaDark width="75px" />
        )}
      </a>
    </div>
  );
};

export default PoweredBy;
